import { createMenuCmdField, EntityManagerConfig } from '../models/entity-config';
import { ServiziRoutes } from '../modules/servizi/servizi.app-manager-routes';

export class ServiziEMC extends EntityManagerConfig {
  override initFields(): void {
    this.cmdFields = [createMenuCmdField(ServiziRoutes.AllCertList)];
  }
}
